import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconCloseRegular(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M16.707 8.707a1 1 0 0 0-1.414-1.414L12 10.586 8.707 7.293a1 1 0 0 0-1.414 1.414L10.586 12l-3.293 3.293a1 1 0 1 0 1.414 1.414L12 13.414l3.293 3.293a1 1 0 0 0 1.414-1.414L13.414 12l3.293-3.293Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
